<template>
  <v-container>
    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.settings.component_name"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.settings.component_name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <p class="text-h6">Variables agitador</p>
    <v-text-field
      prefix="Marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_running"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_running == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Marcha c.:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_continuous_running"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_continuous_running == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Motor:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_engine"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_engine == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Alarma fallo:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_failure_alarm"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_failure_alarm == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Volumen:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Temperatura:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_temperature == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_run_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_run_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden discontinuo:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_discontinuous_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_discontinuous_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Tiempo marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_running_time"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_running_time == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Tiempo paro:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_stopped_time"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_stopped_time == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Velocidad variador:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_variator_speed"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_variator_speed == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <p class="text-h6">Variables c. volumen</p>
    <v-text-field
      prefix="Valor tara: N/A"
      class="ml-3 mr-3"
      disabled
      v-model="selectedItem.customized.variable_volume_tare_value"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_tare_value == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden tara:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume_tare_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_tare_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Resultado tara:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume_tare_result"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_tare_result == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Valor calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume_calibration_value"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_calibration_value == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume_calibration_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_calibration_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Resultado calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_volume_calibration_result"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_volume_calibration_result == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <p class="text-h6">Variables c. temperatura</p>
    <v-text-field
      prefix="Valor tara:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_tare_value"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_temperature_tare_value == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden tara:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_tare_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_temperature_tare_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Resultado tara:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_tare_result"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.variable_temperature_tare_result == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Valor calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_calibration_value"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="
        selectedItem.customized.variable_temperature_calibration_value == null ? updateEditing(true) : null
      "
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Orden calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_calibration_order"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="
        selectedItem.customized.variable_temperature_calibration_order == null ? updateEditing(true) : null
      "
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Resultado calibración:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_temperature_calibration_result"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="
        selectedItem.customized.variable_temperature_calibration_result == null ? updateEditing(true) : null
      "
      @click="updateEditing(true)"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "QLVNAgitatorProperties",

  data() {
    return {};
  },
  computed: {
    ...mapState(["selectedItem"]),
    ...mapState("nodered", ["client"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),
  },

  created() {},
};
</script>

<style></style>
